export default __webpack_public_path__ + "static/media/4.d46c7839.png";